import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import Component from './utils/component';
import * as dom from './utils/dom';
import * as type from './utils/type';
import * as utils from './utils/index';
import defaultOptions from './defaultOptions';

var bulmaCollapsible = /*#__PURE__*/function (_Component) {
  _inherits(bulmaCollapsible, _Component);

  var _super = _createSuper(bulmaCollapsible);

  function bulmaCollapsible(element) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, bulmaCollapsible);

    _this = _super.call(this, element, options, defaultOptions); //Bind events to current class

    _this.onTriggerClick = _this.onTriggerClick.bind(_assertThisInitialized(_this));
    _this.onTransitionEnd = _this.onTransitionEnd.bind(_assertThisInitialized(_this)); // Initiate plugin

    _this._init();

    return _this;
  }
  /**
   * Initiate all DOM element corresponding to selector
   * @method
   * @return {Array} Array of all Plugin instances
   */


  _createClass(bulmaCollapsible, [{
    key: "_init",

    /**
     * Initiate plugin
     * @method init
     * @return {void}
     */
    value: function _init() {
      // Save original element height
      this._originalHeight = this.element.style.height;
      this._parent = this.element.dataset.parent;

      if (this._parent) {
        var parent = this.options.container.querySelector("#".concat(this._parent));
        this._siblings = dom.querySelectorAll(this.options.selector, parent) || [];
      }

      this._triggers = this.options.container.querySelectorAll("[data-action=\"collapse\"][href=\"#".concat(this.element.id, "\"], [data-action=\"collapse\"][data-target=\"").concat(this.element.id, "\"]")) || null;

      if (this._triggers) {
        this._triggers.on('click touch', this.onTriggerClick);
      }

      this._transitionEvent = utils.whichTransitionEvent();

      if (this._transitionEvent) {
        this.element.on(this._transitionEvent, this.onTransitionEnd);
      } // Set initial state


      if (this.element.classList.contains('is-active')) {
        this.expand();
      } else {
        this.collapse();
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      // Unbind all event listener from triggers
      if (this._triggers) {
        this._triggers.off('click touch', this.onTriggerClick, false);
      }
    }
    /**
     * Check is element is collapsed
     * @method init
     * @return {Boolean} true if element is collapsed(closed) else false
     */

  }, {
    key: "collapsed",
    value: function collapsed() {
      return this._collapsed;
    }
    /**
     * Expand(Open) element
     * @method init
     * @return {void}
     */

  }, {
    key: "expand",
    value: function expand() {
      var _this2 = this;

      if (typeof this._collapsed !== 'undefined' && !this._collapsed) {
        return;
      }

      this.emit('before:expand', this);
      this._collapsed = false; // Close all siblings (based on data-parent attribute) if allowMultiple option set to False

      if (this._parent && !type.BooleanParse(this.options.allowMultiple)) {
        this._siblings.forEach(function (sibling) {
          if (!sibling.isSameNode(_this2.element)) {
            if (sibling.bulmaCollapsible) {
              sibling.bulmaCollapsible('close');
            }
          }
        });
      } // Apply style to show (expand) collapsible element


      this.element.style.height = this.element.scrollHeight + 'px';
      this.element.classList.add('is-active');
      this.element.setAttribute('aria-expanded', true); // Add 'is-active" class to all triggers

      if (this._triggers) {
        this._triggers.forEach(function (trigger) {
          trigger.classList.add('is-active');
        });
      }

      this.emit('after:expand', this);
    }
    /**
     * Shortcut to expand method
     */

  }, {
    key: "open",
    value: function open() {
      this.expand();
    }
    /**
     * Collapse(Close) element
     * @method init
     * @return {void}
     */

  }, {
    key: "collapse",
    value: function collapse() {
      if (typeof this._collapsed !== 'undefined' && this._collapsed) {
        return;
      }

      this.emit('before:collapse', this);
      this._collapsed = true; // Apply style to hide (collapse) collapsible element

      this.element.style.height = 0;
      this.element.classList.remove('is-active');
      this.element.setAttribute('aria-expanded', false); // Remove 'is-active" class from all triggers

      if (this._triggers) {
        this._triggers.forEach(function (trigger) {
          trigger.classList.remove('is-active');
        });
      }

      this.emit('after:collapse', this);
    }
    /**
     * Shortcut to collapse method
     */

  }, {
    key: "close",
    value: function close() {
      this.collapse();
    }
    /**
     * Trigger listener to Toggle element state
     * @method init
     * @param {event} event
     * @return {void}
     */

  }, {
    key: "onTriggerClick",
    value: function onTriggerClick(event) {
      event.preventDefault();

      if (this.collapsed()) {
        event.currentTarget.classList.add('is-active');
        this.expand();
      } else {
        event.currentTarget.classList.remove('is-active');
        this.collapse();
      }
    }
    /**
     * Listener on CSS transition end
     * @param {event} event
     * @return {void}
     */

  }, {
    key: "onTransitionEnd",
    value: function onTransitionEnd(event) {
      if (!this._collapsed) {
        this.element.style.height = this._originalHeight;
      }
    }
  }], [{
    key: "attach",
    value: function attach() {
      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.is-collapsible';
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _get(_getPrototypeOf(bulmaCollapsible), "attach", this).call(this, selector, options, defaultOptions);
    }
  }]);

  return bulmaCollapsible;
}(Component);

export { bulmaCollapsible as default };